import {
	COMPONENT_ATTR_CAN_REVIEW, COMPONENT_ATTR_EDITING_ENABLED,
	COMPONENT_ATTR_ID, COMPONENT_ATTR_NAME, COMPONENT_ATTR_NEW_VALUE, COMPONENT_ATTR_UPDATING,
	COMPONENT_NAME
} from '../constants';
import { getAttributesFromEditableFieldViewElement } from '../utils';

export const upcastEditableField = ( viewElement, { writer, consumable } ) => {
	const container = writer.createElement( COMPONENT_NAME );

	const { id, name, updating, newValue, canReview, enabled } = getAttributesFromEditableFieldViewElement( viewElement );

	writer.setAttribute( COMPONENT_ATTR_ID, id, container );
	writer.setAttribute( COMPONENT_ATTR_NAME, name, container );
	writer.setAttribute( COMPONENT_ATTR_UPDATING, updating, container );
	writer.setAttribute( COMPONENT_ATTR_NEW_VALUE, newValue, container );
	writer.setAttribute( COMPONENT_ATTR_CAN_REVIEW, canReview, container );
	writer.setAttribute( COMPONENT_ATTR_EDITING_ENABLED, enabled, container );

	consumable.consume( viewElement, container );

	return container;
};
